export function ConsignmentBankReceiptReview({
  checked,
  reference,
  disabled,
  onChecked,
  onReference,
}: {
  checked: boolean;
  reference: string;
  disabled: boolean;
  onChecked: (value: boolean) => void;
  onReference: (value: string) => void;
}): JSX.Element {
  return (
    <fieldset className="tcvs-bank-receipt-review" disabled={disabled}>
      <legend>Bank receipt review (manual)</legend>
      <label>
        Marketplace payout and bank deposit evidence reference
        <input
          value={reference}
          minLength={3}
          maxLength={500}
          required
          onChange={(e) => onReference(e.target.value)}
        />
      </label>
      <label>
        <input type="checkbox" checked={checked} onChange={(e) => onChecked(e.target.checked)} /> I
        matched the relevant marketplace funds to actual business-bank receipt and reviewed holds,
        refunds and disputes before approving or making this payment.
      </label>
    </fieldset>
  );
}
